<template>
	<div>
		<div class="list-btn">
			
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<Input search enter-button placeholder="请输入地址/名称查询" style="width: 500px;" />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					type:''
				},
				
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					},{
						title: 'id',
						key: 'id'
					}, {
						title: '等级',
						key: 'rank'
					},
					{
						title: '标题',
						key: 'title'
					},
					{
						title: '值1',
						key: 'value'
					},
					{
						title: '值2',
						key: 'value1'
					},
					{
						title: '值3',
						key: 'value2'
					},
					{
						title: '备注',
						key: 'remark'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					}
				],
				data6: [
					
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'POST',
				    url: http.url + '/mac/message/log/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/macMessageLog/list.vue